import React, { FC } from 'react';
import parseClassnames from '../../helpers/parseClassnames';
import { DialogContentProps } from '../types';
import { DIALOG_SHEET_COL_PROPS, DIALOG_CONTENT_COL_PROPS } from '../constants';

import { Row, Col } from '../../GridV2';

import MainTitle from './ui/MainTitle';
import Body from './ui/Body';
import MainActions from './ui/MainActions';
import AlertActions from './ui/AlertActions';

const DialogContent: FC<DialogContentProps> = ({
  type = 'm',
  mainTitle,
  body,
  action,
  action2,
  action3,
  cancelAction,
  confirmAction,
  rootClassName = '',
  className = '',
  children,
  dark,
  ...other
}) => {
  const totalInnerCols = {
    xs: DIALOG_CONTENT_COL_PROPS[type].xs,
    sm: DIALOG_CONTENT_COL_PROPS[type].sm,
    md: DIALOG_CONTENT_COL_PROPS[type].md,
    lg: DIALOG_CONTENT_COL_PROPS[type].lg,
  };

  return (
    <Row
      className={parseClassnames(
        rootClassName,
        type !== 's' ? 'px-20 sm:px-0' : '',
      )}
      totalCols={
        type === 'full'
          ? { xs: DIALOG_SHEET_COL_PROPS.full.xs }
          : {
              xs: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].xs,
              sm: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].sm,
              md: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].md,
              lg: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].lg,
            }
      }
      nowrap
    >
      <Col
        className={parseClassnames(
          className,
          type === 's' ? 'py-48 sm:py-56' : 'pt-56 pb-48 sm:pb-56',
        )}
        offset={DIALOG_CONTENT_COL_PROPS[type].offset}
        {...totalInnerCols}
        {...other}
      >
        {mainTitle && (
          <MainTitle
            type={type}
            mainTitle={mainTitle}
            dark={dark}
            hasMoreElements={
              !!(
                body ||
                action ||
                action2 ||
                action3 ||
                cancelAction ||
                confirmAction ||
                children
              )
            }
          />
        )}
        {body && (
          <Body
            type={type}
            body={body}
            dark={dark}
            hasMoreElements={
              !!(
                action ||
                action2 ||
                action3 ||
                cancelAction ||
                confirmAction ||
                children
              )
            }
          />
        )}
        {children}
        {(confirmAction || cancelAction) && (
          <AlertActions
            type={type}
            cancelAction={cancelAction}
            confirmAction={confirmAction}
            dark={dark}
            totalInnerCols={totalInnerCols}
            hasMoreElements={!!(action || action2 || action3)}
          />
        )}
        {(action || action2 || action3) && (
          <MainActions
            type={type}
            action={action}
            action2={action2}
            action3={action3}
            dark={dark}
            totalInnerCols={totalInnerCols}
          />
        )}
      </Col>
    </Row>
  );
};

export default DialogContent;
